import React from 'react';
import { Link } from 'react-router-dom';
import {
  Search, Share2, MousePointerClick, FileText, Palette,
  TrendingUp, Globe, Video, BarChart3, Brain, Shield, CheckCircle2, ArrowRight
} from 'lucide-react';
import PricingTiers from './PricingTiers';

const iconMap = { Search, Share2, MousePointerClick, FileText, Palette, TrendingUp, Globe, Video, BarChart3, Brain, Shield };

const ServiceDetailCard = ({ service, index, onQuote }) => {
  const Icon = iconMap[service.icon];
  return (
    <article
      id={service.slug}
      data-testid={`service-detail-${service.slug}`}
      className="scroll-mt-32 rounded-2xl border border-gray-200 bg-gradient-to-br from-white to-orange-50 p-6 sm:p-10 shadow-sm"
    >
      <div className="grid lg:grid-cols-5 gap-8 mb-8">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-4 mb-4">
            <div className="w-14 h-14 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#D97904' }}>
              <Icon className="w-7 h-7 text-white" />
            </div>
            <span className="text-sm font-bold text-gray-400">{String(index + 1).padStart(2, '0')}</span>
          </div>
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'var(--font-serif)' }}>
            {service.title}
          </h2>
          <p className="font-semibold mb-3" style={{ color: '#D97904' }}>{service.tagline}</p>
          <p className="text-gray-600 leading-relaxed mb-4">{service.description}</p>
          <Link
            to={`/services/${service.slug}`}
            data-testid={`learn-more-${service.slug}`}
            className="inline-flex items-center gap-1 font-semibold hover:gap-2 transition-all"
            style={{ color: '#D97904' }}
          >
            Learn more &amp; FAQs <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <div className="lg:col-span-3">
          <h3 className="text-base md:text-lg font-bold text-gray-900 mb-4">What you get</h3>
          <ul className="grid sm:grid-cols-2 gap-3">
            {service.deliverables.map((d) => (
              <li key={d} className="flex items-start gap-2 text-gray-700 text-sm sm:text-base">
                <CheckCircle2 className="w-5 h-5 mt-0.5 flex-shrink-0" style={{ color: '#D97904' }} />
                {d}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <PricingTiers service={service} onQuote={onQuote} />
    </article>
  );
};

export default ServiceDetailCard;
